import { gql } from '@apollo/client';

export default gql`
  fragment PostFields on Post {
    id
    title
    propertyType
    views
    date
    modified
    link
    author {
      id
      name
      nickname
      description
      link
      total_post
    }
    categories {
      id
      name
      link
    }
    tags {
      id
      name
      link
    }
    project {
      id
      name
      propertyType
      developer
      roomTypes {
        name
        status
        min_size
        max_size
      }
      location {
        zone {
          label
          value
          link
          parent {
            value
            label
            link
          }
        }
        district {
          label
          value
          link
          parent {
            value
            label
            link
          }
        }
        road {
          label
          value
          link
          parent {
            value
            label
            link
          }
        }
      }
      transportations {
        value
        label
        link
      }
      priceTypes {
        starting_price
        level {
          value
          label
        }
      }
    }
    postCategory
    videoType
    featuredImage {
      url
      title
      width
      height
    }
    totalComments
    embedVideo
    excerpt
  }
`;
